import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const CollectionBasicInfoComponent = ({
    selectLMSCollections, handleInnerFormChange
}: any) => {

    return (
        <>
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="Title"
                            labelField="Title"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Title'
                                );
                            }}
                            type="text"
                            value={selectLMSCollections?.Title}
                        />

                        <div className='col-span-full'>
                            <InputContainer
                                label="Description"
                                name="Description"
                                onValueChange={(event: any) => {
                                    handleInnerFormChange(
                                        event,
                                        'Description'
                                    )
                                }}
                                type="rte"
                                value={selectLMSCollections?.Description}
                            />
                        </div>
                    </div>

                }
                expandedPanel="BasicInfo"
                headerTitle="Basic Info"
            />
        </>
    )
}
export default CollectionBasicInfoComponent;
